<template>
    <div id="app" ref="app" :class="langClass">
        <siteNav></siteNav>
         <div class="loading-bar" id="loading-bar" :class="loadingBg">
          <div class="inner">
            <app-loading-background-riboca></app-loading-background-riboca>
          </div>
        </div>
        <router-view :key="$route.params.slug" ></router-view>
        <siteFooter></siteFooter>
    </div>
</template>

<script>
  import siteNav from './components/SiteNav'
  import siteFooter from './components/siteFooter'
  import appLoadingBackgroundRiboca from './transitions/LoadingBackgroundRibocaSequence'
  import {store} from './store/store'
  export default {
    name: 'app',
    components: { siteNav, siteFooter,appLoadingBackgroundRiboca },
    data() {
      return {
        onScroll:0,
        loadingBg:'darg-bg',
        langClass:'',
      }
    },
    mounted() {
      // check to see if favArtists exists in local storage
      if(localStorage.getItem('favArtists')) {
        // if it does get the retrieved values
        let retrievedVals = JSON.parse(localStorage.getItem('favArtists'));
        // now despatch those to the store
        store.dispatch('setFavArtists', retrievedVals);
      }
      if(localStorage.getItem('favVenues')) {
        // if it does get the retrieved values
        let retrievedVals = JSON.parse(localStorage.getItem('favVenues'));
        // now despatch those to the store
        store.dispatch('setFavVenues', retrievedVals);
      }
      if(localStorage.getItem('favEvents')) {
        // if it does get the retrieved values
        let retrievedVals = JSON.parse(localStorage.getItem('favEvents'));
        // now despatch those to the store
        store.dispatch('setFavEvents', retrievedVals);
      }
      this.getLanguage();
    },
    computed: {
      // currentCompnent() {
      //   return 'appLoadingBackgroundRiboca';
      // }
      lang() {
        return this.$store.state.langUrl;
      }
    },
    watch: {
      lang(newValue) {
        if (newValue == 'ru') {
          this.langClass = 'ru';
        } else {
          this.langClass = '';
        }
        this.getLanguage();
      }
    },
    methods: {
       getLanguage() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/v1/language.json';
        let vm = this;
        this.$http.get(url).then((response) => {
          store.dispatch('setLanguage', response.data.data);
        });
      },
    }
  }
</script>

<style lang="scss">
  // @import '/node_modules/flexboxgrid/dist/flexboxgrid.min.css';
</style>


// WEBPACK FOOTER //
// src/App.vue